<template>
  <div class="activity-wrap">
    <app-header />
    <div class="auto act-head">
      <div class="slogn-btn">
        <a class="btn-buy btn-buy1" @click="goUrl(116)"></a>
        <a class="btn-buy btn-buy2" @click="goUrl(73)"></a>
      </div>
    </div>
    <div class="content content1">
      <div class="auto">
        <h2>大智慧「365」<small>基本面、技术面、资金面 一站解决炒股难题</small></h2>
        <div class="mod mod_th">
          <h3>Level2行情<span>千档行情、全息盘口，主力控盘区域一目了然</span></h3>
          <img src="../../assets/images/activity/activity202309/img1.jpg" alt="" width="100%">
          <p class="align-c">Level2超级盘口对于分析盘中买卖盘、盘后复盘有极其重要的作用。</p>
          <p class="align-c">千档盘口让你看到别人看不到的行情，一眼看穿主力大资金潜伏价位；</p>
          <p class="align-c">全息盘口完美展示个股每一笔的成交情况，是盘中跟踪、盘后复盘利器。</p>
        </div>
        <div class="mod">
          <h3>热钱追踪<span>DDE当日资金流排序功能，助力投资者紧跟热钱的脚步。</span></h3>
          <img src="../../assets/images/activity/activity202309/img2.jpg" alt="" width="100%">
        </div>
        <div class="mod mod-swzf">
          <h3>四维战法</h3>
          <p class="dot">黄金波段：揭示“顶背离”“底背离”</p>
          <p class="dot">黄金狙击：揭示行情“变盘信号”</p>
          <p class="dot">市场热度：揭示市场“多空力量强弱”对比</p>
          <p class="dot">GDX指标：深度挖掘“活跃资金”的市场行为</p>
          <img src="../../assets/images/activity/activity202309/img3.jpg" alt="" width="100%">
        </div>
        <div class="content-bottom-btn">
          <p>大智慧「365」</p>
          <a @click="goUrl(116)">立即抢购</a>
        </div>
      </div>
    </div>
    <div class="content content2">
      <div class="auto">
        <h2>大智慧「专业版」<small>专业投资的不二选择</small></h2>
        <div class="mod mod_th">
          <h3>超赢实时监控<span>主力大单、散户动向一目了然</span></h3>
          <img src="../../assets/images/activity/activity202309/img4.jpg" alt="" width="100%">
        </div>
        <div class="mod">
          <h3>龙头看盘<span>日内打板利器</span></h3>
          <img src="../../assets/images/activity/activity202309/img5.jpg" alt="" width="100%">
        </div>
        <div class="mod mod-jzjy">
          <h3>九转交易<span>（TS时间序列-仅支持32位）</span></h3>
          <p>按照国际算法，采用特定时间序列，识别市场趋势的潜在转折点。</p>
          <img src="../../assets/images/activity/activity202309/img6.jpg" alt="" width="100%">
        </div>
        <div class="content-bottom-btn">
          <p>立省800元</p>
          <a @click="goUrl(73)">立即抢购</a>
        </div>
      </div>
    </div>
    <div class="act-foot">风险提示：本产品不涉及投资咨询及投资顾问服务，所展示信息不构成投资建议；数据基于历史，不代表未来趋势；<br/>所有工具都有局限性，适合不同情况下的市场，仅供参考，请理性投资，控制风险，投资有风险，入市需谨慎。</div>
  </div>
</template>
<script>
</script>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data () {
    return {
      token: '',

    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {

  },
  methods: {
    goUrl (key) {
      let routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key}})
      let {href} = routerDate
      window.open(href, "_blank")
    }
  }
}
</script>
<style lang="scss" scoped>
div, p, span, a{
  box-sizing: border-box;
}
.activity-wrap{
  background:#7a0b14 url(../../assets/images/activity/activity202309/bg1.jpg) no-repeat center 100px;
  .auto{
    width: 1200px;
    margin: 0px auto;
    position: relative;
  }
  .act-head{    
    padding-top:915px;
  }
  .slogn-btn{
    position: absolute;
    left:0;
    right:0;
    bottom: 100px;
    a{
      position:absolute;
      left:50%;
      height:212px;
      bottom:0;
      &.btn-buy1{
        width: 512px;
        margin-left:-554px;
      }
      &.btn-buy2{      
        width: 568px;
        margin-left:-17px;
      }
    }
  }
  .content1{
    padding:80px 0 100px;color:#fff;
    background:url(../../assets/images/activity/activity202309/bg2.jpg) no-repeat center top,url(../../assets/images/activity/activity202309/bg6.jpg) no-repeat center top,url(../../assets/images/activity/activity202309/bg3.jpg) no-repeat center bottom;
    .content-bottom-btn a{
      background:url(../../assets/images/activity/activity202309/btn1.png) no-repeat 0 0;
    }
  }
  .content2{
    padding:80px 0 100px;color:#fff;
    background:url(../../assets/images/activity/activity202309/bg4.jpg) no-repeat center top,url(../../assets/images/activity/activity202309/bg5.jpg) no-repeat center bottom;
    .content-bottom-btn a{
      background:url(../../assets/images/activity/activity202309/btn2.png) no-repeat 0 0;
    }
  }
  .content{
    h2{
      text-align:center;font-size:52px;
      small{
        display:block;font-size:41px;margin-top:10px;
      }
    }
    .mod{
      padding:0 40px 30px;
      background:#b0222c;
      border:1px solid #fff;
      position:relative;
      margin-top:240px;
      margin-bottom:80px;
      z-index:1;
      &.mod_th:after{
        content:'';
        position:absolute;left:50%;top:-162px;
        background:url(../../assets/images/activity/activity202309/mod-bg.jpg) no-repeat center top;
        margin-left:-623px;width:1245px;height:124px;z-index:-1;
      }
      &.mod-swzf{
        margin-top:220px;
        h3{
          top:-120px; 
        }
        img{
          margin-top:30px;
        } 
      }
      &.mod-jzjy{
        p{
          margin-top:0;
          margin-bottom:30px;
        }
      }
      h3{
        font-size:50px;
        position:absolute;
        top:-140px;left:-1px;right:-1px;background:url(../../assets/images/activity/activity202309/mod-bg2.png) no-repeat 0 0;height:140px;line-height:140px;padding:0 0 0 44px;
        span{font-size:30px;margin-left:35px;}
      }
      img{
        display:block;
        border:1px solid #fff;
        margin-bottom:30px;
      }
      p{
        font-size:30px;
        margin-top:15px;
        &.align-c{
          text-align:center;
        }
        &.dot{
          padding-left:40px;position:relative;
          &:before{
            content:'';position:absolute;left:0;top:50%;
            background:url(../../assets/images/activity/activity202309/icon-rec.png) no-repeat 0 0;
            width:18px;height:18px;margin-top:-8px;
          }
        }
      }
    }
    .content-bottom-btn{
      p{
        text-align:center;
        font-size:53px;        
      }
      a{
        display:block;        
        width:757px;height:139px;text-indent:-999px;overflow:hidden;
        margin:30px auto 0;
      }
    }
  }
  .act-foot{
    background:#3a3a3a;
    text-align:center;
    line-height:1.6;
    color:#fff;font-size:16px;
    padding:40px 0 50px;
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/activity/activity202309.vue